//import { createClient } from '@supabase/supabase-js'

//const supabaseUrl = 'https://qizijxlmkbgtmftkhggd.supabase.co'
//const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFpemlqeGxta2JndG1mdGtoZ2dkIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzQyMDg3NzksImV4cCI6MjA4OTc4NDc3OX0.oI9kOD1BdXCvMACxk6IatXnX_9CTy-FxoUKhxOB9F5E'

//export const supabase = createClient(supabaseUrl, supabaseKey)

import { createClient } from "@supabase/supabase-js"

const supabaseUrl =
  "https://qizijxlmkbgtmftkhggd.supabase.co"

const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFpemlqeGxta2JndG1mdGtoZ2dkIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzQyMDg3NzksImV4cCI6MjA4OTc4NDc3OX0.oI9kOD1BdXCvMACxk6IatXnX_9CTy-FxoUKhxOB9F5E'

export const supabase = createClient(
  supabaseUrl,
  supabaseKey,
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: false
    }
  }
)
